import React from "react";
import { Link, Redirect } from "react-router-dom";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import Form from "../../components/common/form";
import http from "../../services/httpService";
import auth from "../../services/authService";
import BrandingLogo from "../../components/common/BrandingLogo";
import BrandingAppTitle from "../../components/common/BrandingAppTitle";
import { appVersion } from "../../config";

class ResetPasswordForm extends Form {
  state = {
    data: {
      password: "",
      confirmPassword: "",
    },
    errors: {},
    token: "",
    redirectTo: null,
  };

  schema = {
    password: Joi.string().min(8).max(255).required().label("Password"),
    confirmPassword: Joi.any()
      .valid(Joi.ref("password"))
      .required()
      .options({ language: { any: { allowOnly: "must match password" } } })
      .label("Confirm password"),
  };

  componentDidMount() {
    const params = new URLSearchParams(this.props.location?.search || "");
    const token = params.get("token") || "";

    if (!token) {
      toast.error("Invalid or missing reset token.");
      this.setState({ redirectTo: "/forgot-password" });
      return;
    }

    this.setState({ token });
  }

  doSubmit = async () => {
    try {
      const { token, data } = this.state;
      await http.post(`/client/reset-password`, {
        token,
        password: data.password,
      });

      toast.success("Password reset successful. Please login.");
      this.setState({ redirectTo: "/login" });
    } catch (ex) {
      const errorMessage =
        (ex.response &&
          (typeof ex.response.data === "string"
            ? ex.response.data
            : ex.response.data?.error)) ||
        ex.message ||
        "Request failed.";
      toast.error(errorMessage);
    }
  };

  render() {
    if (auth.getCurrentUser()) return <Redirect to="/home" />;
    if (this.state.redirectTo) return <Redirect to={this.state.redirectTo} />;

    return (
      <React.Fragment>
        <div className="d-flex flex-column justify-content-center align-items-center min-vh-100">
          <form
            className="form-signin border border-light rounded shadow mb-3"
            onSubmit={this.handleSubmit}
          >
            <BrandingLogo className="mx-auto d-block mb-2" maxHeight="45px" />
            <p className="text-muted text-center small m-3">Client Portal</p>
            <hr className="mb-5" />

            {this.renderFloatingInput("password", "New password", "password", "new-password")}
            {this.renderFloatingInput("confirmPassword", "Confirm password", "password", "new-password")}

            <div className="d-flex justify-content-between align-items-center mt-3">
              <Link className="small text-muted" to="/login">Back to login</Link>
            </div>

            {this.renderButton("Reset password", <i className="fa fa-key" />, "block")}
          </form>
          <p className="text-muted text-center small">
            © {new Date().getFullYear()} <BrandingAppTitle /> {appVersion && <span>v{appVersion}</span>}
          </p>
        </div>
      </React.Fragment>
    );
  }
}

export default ResetPasswordForm;
